export default "__VITE_ASSET__DdUfbUWf__"